import React, {Component} from 'react';
import Container from 'react-bootstrap/Container';
import { detectDevice } from '../../controller';
	
let isCompatible = detectDevice()
export default class Management extends Component {
	loopingData = () => {
		let El = []
		let res_data = [
			{
				'name': 'Priyo Suyono',
				'job': 'President Director',
				'profile': 'https://minio.nexa.net.id/nexa/pak_priyo.png',
				"style":{"width":"100%"}
			},
			{
				'name': 'Adhi Darminto',
				'job': 'Director',
				'profile': 'https://minio.nexa.net.id/nexa/pak_adhi.png',
				'style':{"width":"100%"}
			},
			// {
			// 	'name': 'Sianne Ho',
			// 	'job': 'Finance and Accounting Manager',
			// 	'profile': './assets/images/about/women.png'
			// },
			// // {
			// // 	'name': 'Atalia Citra',
			// // 	'job': 'Marketing and Communication Coordinator',
			// // 	'profile': './assets/images/about/women.png'
			// // },
			// {
			// 	'name': 'Onnie Kurnia',
			// 	'job': 'Customer Experience Assistant Manager',
			// 	'profile': './assets/images/about/women.png'
			// },
			// {
			// 	'name': 'Bayu Pringgandani',
			// 	'job': 'Sales Coordinator',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Jatmiko Ari Wibowo',
			// 	'job': 'Sales (Gov-Edu) Team Leader',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Apit Priono',
			// 	'job': 'Technical, Infrastructure, and Helpdesk Manager',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Wijanarko Nugroho',
			// 	'job': 'NOC IP Core Assistant Manager',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Sidik Pramono',
			// 	'job': 'Technical (Salatiga Branch) Assistant Manager',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Indra Permana',
			// 	'job': 'Helpdesk Supervisor',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Khamim Budi',
			// 	'job': 'Base Station and Base Station Support Supervisor',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Rahmat Nur Setiyanto',
			// 	'job': 'Delivery Control Service Supervisor',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Argyan Chandra',
			// 	'job': 'Access Support Supervisor',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Dika Afif',
			// 	'job': 'Operation Support Supervisor',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Edy Kristanto',
			// 	'job': 'Application and Content Provider Manager',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Indra Maulana',
			// 	'job': 'Application and Features Supervisor',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Dwi Aji Prabowo',
			// 	'job': 'Application Core and Quality Supervisor',
			// 	'profile': './assets/images/about/people.png'
			// },
			// {
			// 	'name': 'Anne Margaretha',
			// 	'job': 'Human Resource, General Affair, and Legal Manager',
			// 	'profile': './assets/images/about/women.png'
			// },
			{
				'name': 'Budiyanto',
				'job': 'Technical Director',
				'profile': 'https://minio.nexa.net.id/nexa/pak_budi.png',
				'style' : {"width":"100%", "height":"auto"}
			}
			
		]

		res_data.forEach((row, index) => {
			El.push(
				<div key={index} className="col-6 m-0 d-flex m-auto">
					<div className="card card-management mb-3">
						<img alt="" src={isCompatible ? "https://minio.nexa.net.id/nexa/bg.webp" : "https://minio.nexa.net.id/nexa/bg.jpeg"} className="bg-management" />
						<div className="w-100 card-hover"
							onMouseEnter={e => {
								document.getElementById('__imgHover_'+index).classList.add('img-hover')
								document.getElementById('__cardHover_'+index).classList.add('bg-hover')
								document.querySelector('#__cardHover_'+index + ' .fw-bold.mb-0.fs-16').classList.remove('bannerandmenu-text1')
							}}
							onMouseLeave={e => {
								document.getElementById('__imgHover_'+index).classList.remove('img-hover')
								document.getElementById('__cardHover_'+index).classList.remove('bg-hover')
								document.querySelector('#__cardHover_'+index + ' .fw-bold.mb-0.fs-16').classList.add('bannerandmenu-text1')
							}}
							style={{"position":"absolute", "bottom":"0", "height":"1rem","borderRadius":"10px"}}>
							<img alt={row.name} src={row.profile} id={"__imgHover_"+index} className="img-profile" style={row.style} />
							<div className="card-body bg-white w-100 card-body-hover" id={"__cardHover_"+index} style={{"position":"absolute","bottom":"0","zIndex":"1","height":"100px"}}>
							<span className="bannerandmenu-text1 fw-bold mb-0 fs-16">{row.name}</span>
								<div className="card-footer bg-unset p-0 pt-2 mt-2 pb-2" style={{"lineHeight":"1.3", fontSize:"0.8rem"}}>
								{row.job}
								</div>
							</div>
						</div>
						
					</div>
				 </div>
			)
		})
		return El;
	}
    render(){
        return (
        	<section>
        	<style jsx="true">
        	{`
        		.card.card-management {
        			height: 17rem	;
        		}
        	`}
        	</style>
        	<div className="home-section6 mt-5 mb-5 d-block" style={{"height": "auto"}}>
	          	<div className="home-container31 p-0 pt-5 pb-5 row m-0">
		          	<div className="nexatel-container18 p-0">
		          		<span className="nexatel-text40">Company</span>
		          		<h1 className="nexatel-text41 fw-bold">Management</h1>
		          		<div className="row p-0 mt-5 me-2 ms-2">
							
								{this.loopingData()}
					
			          		
		          		</div>
		          	</div>
	          	</div>
	        </div>
        	</section>
        )
    }
}